<div class="tm-login-layout">
  @if (auth.isLogged()) {
    <header class="user-info-header">
      <div class="user-info">
        <p-avatar icon="pi pi-user" shape="circle" class="user-avatar" />
        <div class="user-avatar-container">
          <p class="user-email">{{ auth.currentUser()?.email || '-' }}</p>
          <p-button
            link
            size="small"
            class="switch-user-link"
            [style]="{ 'padding-left': '0' }"
            (onClick)="onSwitchUser()"
            severity="success"
          >
            Trocar de usuário
          </p-button>
        </div>
      </div>
    </header>
  }
  <main>
    <div class="logo-container">
      <img src="tmdigital.svg" alt="tmdigital" class="logo" />
    </div>
    <router-outlet />
  </main>
  <footer>
    <p>&copy; {{ currentYear }} tmdigital. Todos os direitos reservados.</p>
  </footer>
</div>
